'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _jsx = require('@babel/runtime/helpers/jsx');
var _objectSpread = require('@babel/runtime/helpers/objectSpread2');
var React = require('react');
var list = require('@andes/list');
var classNames = require('classnames');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var keyboardCodes = require('@andes/common/build/constants/keyboardCodes');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _jsx__default = /*#__PURE__*/_interopDefaultLegacy(_jsx);
var _objectSpread__default = /*#__PURE__*/_interopDefaultLegacy(_objectSpread);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
const SPLIT_REGEX = new RegExp(/(\s|-)/g);
const getSuggestions = _ref => {
  let {
    suggestions,
    onlyStartWith,
    showCurrentOption
  } = _ref;
  return value => {
    const suggestedOptions = suggestions.reduce((listToSuggest, listValue) => {
      const valueToSearch = value.toLowerCase();
      const valueName = listValue.name.toLowerCase();
      let index = valueName.indexOf(valueToSearch);
      if (index < 0) {
        index = valueName.normalize('NFD').replace(/[\u0300-\u036f]/g, '').indexOf(valueToSearch);
      }
      let countIndex = 0;
      valueName.split(SPLIT_REGEX).forEach((word, i) => {
        const partialIndex = word.indexOf(valueToSearch);
        const newIndex = partialIndex + countIndex + i;
        if (partialIndex !== -1 && valueName[newIndex - 1] === ' ') {
          index = newIndex;
        }
        countIndex += word.length;
      });
      if (index >= 0) {
        const newOpt = _objectSpread__default["default"](_objectSpread__default["default"]({}, listValue), {}, {
          prev: listValue.name.substr(0, index),
          mid: listValue.name.substr(index, value.length),
          pos: listValue.name.substr(index + value.length)
        });
        if (newOpt.prev.slice(-1) === ' ' || newOpt.prev.slice(-1) === '-' || newOpt.prev.slice(-1) === '/') {
          listToSuggest.secondary.push(newOpt);
        } else if (index === 0) {
          listToSuggest.startsWith.push(newOpt);
        } else {
          listToSuggest.contains.push(newOpt);
        }
      }
      return listToSuggest;
    }, {
      startsWith: [],
      secondary: [],
      contains: []
    });
    const currentValue = {
      id: '',
      prev: '',
      mid: value,
      pos: '',
      name: value
    };
    let lists = [];
    if (onlyStartWith) {
      lists = suggestedOptions.startsWith;
    } else {
      lists = [...suggestedOptions.startsWith, ...suggestedOptions.secondary, ...suggestedOptions.contains];
    }
    const currentValueInList = lists.find(option => option.name.toLowerCase() === currentValue.name.toLowerCase());
    return Promise.resolve(showCurrentOption && !currentValueInList ? [currentValue, ...lists] : [...lists]);
  };
};
function renderItem(item) {
  const bold = document.createElement('b');
  bold.innerText = item.mid;
  const span = document.createElement('span');
  span.append(item.prev, bold, item.pos);
  return span;
}
const _excluded = ["mid", "pos", "prev"];
const listOpenClass = 'andes-dropdown--open';
const listHoverClass = 'andes-dropdown-item-hover';
const listItemClass = 'andes-list__item';
const autocompleteClass = 'andes-autocomplete';
class AutocompleteHandler {
  constructor(options) {
    const {
      autocompleteOff = true,
      container,
      field,
      keyStart = '',
      list,
      onlyStartWith = false,
      onSelect,
      renderItem: renderItemProps,
      showCurrentOption = false,
      showSuggestionsOnFocus = false,
      startIndex = 0
    } = options;
    this.field = field;
    this.field.autocomplete = 'off';
    this.field.ariaExpanded = 'false';
    this.container = container;
    this.id = field.id;
    this.list = list;
    this.keyStart = keyStart;
    this.onSelect = onSelect;
    this.autocompleteOff = autocompleteOff;
    this.showCurrentOption = showCurrentOption;
    this.showSuggestionsOnFocus = showSuggestionsOnFocus;
    this.onlyStartWith = onlyStartWith;
    this.startIndex = startIndex;
    this.itemList = [];
    this.resetItemSelected();
    this.currentSuggestions = [];
    this.itemSelected = 0;
    this.suggestions = typeof options.suggestions === 'function' ? options.suggestions(options) : getSuggestions(options);
    this.renderItem = typeof renderItemProps === 'function' ? renderItemProps : renderItem;
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
    this.onSelectHandler = this.onSelectHandler.bind(this);
    this.drawSuggestions = this.drawSuggestions.bind(this);
  }
  close() {
    var _this$container;
    (_this$container = this.container) === null || _this$container === void 0 || _this$container.classList.remove(listOpenClass);
    this.field.setAttribute('aria-expanded', 'false');
    this.field.removeAttribute('aria-activedescendant');
    if (this.list) {
      this.list.innerHTML = '';
    }
  }
  open() {
    var _this$container2;
    (_this$container2 = this.container) === null || _this$container2 === void 0 || _this$container2.classList.add(listOpenClass);
    this.field.setAttribute('aria-expanded', 'true');
  }
  onSelectHandler(e, match, suggestion) {
    e.preventDefault();
    e.stopPropagation();
    this.field.value = suggestion;
    this.close();
    const originalValue = _objectWithoutProperties__default["default"](match, _excluded);
    this.onSelect(e, originalValue, this.field.value);
    return false;
  }
  hoverElement() {
    for (let i = 0; i < this.itemList.length; i += 1) {
      if (this.itemSelected >= this.itemList.length) {
        this.itemSelected = 0;
      }
      if (this.itemList[i].classList.contains(listHoverClass)) {
        this.itemList[i].classList.remove(listHoverClass);
      }
      if (this.itemSelected === i) {
        this.itemList[i].classList.add(listHoverClass);
        if (this.id) this.field.setAttribute('aria-activedescendant', "".concat(this.id, "-listbox-option-").concat(i));
      }
    }
  }
  drawSuggestions(values, initial) {
    for (let i = 0; i < values.length; i += 1) {
      var _this$list;
      let value = values[i];
      if (initial) {
        value = {
          id: value.id,
          prev: '',
          mid: this.keyStart,
          pos: value.name.substr(1),
          name: value.name
        };
      }
      const li = document.createElement('li');
      li.classList.add(listItemClass);
      li.setAttribute('role', 'option');
      li.setAttribute('aria-label', value.name);
      if (this.id) li.setAttribute('id', "".concat(this.id, "-listbox-option-").concat(i));
      li.onclick = e => {
        this.onSelectHandler(e, values[i], value.name);
      };
      li.appendChild(this.renderItem(value));
      (_this$list = this.list) === null || _this$list === void 0 || _this$list.appendChild(li);
    }
  }
  getSuggestions(value) {
    return this.suggestions(value).then(matchedSuggestions => {
      this.currentSuggestions = matchedSuggestions;
      return matchedSuggestions;
    });
  }
  onChange() {
    const {
      close,
      open,
      field,
      list,
      startIndex,
      keyStart,
      drawSuggestions,
      showSuggestionsOnFocus
    } = this;
    close();
    if ((field.value.length > startIndex || showSuggestionsOnFocus && !field.value.length) && field.value.match(keyStart)) {
      open();
      let {
        value
      } = field;
      if (keyStart) {
        value = field.value.substring(field.value.indexOf(keyStart), field.value.length);
        if (value === keyStart) {
          this.getSuggestions(value).then(matchedSuggestions => drawSuggestions(matchedSuggestions));
        }
      }
      if (value !== keyStart || showSuggestionsOnFocus && !field.value.length) {
        this.getSuggestions(value).then(matchedSuggestions => {
          this.resetItemSelected();
          if (matchedSuggestions.length) {
            drawSuggestions(matchedSuggestions);
          } else {
            close();
          }
        }).catch(() => close()).finally(() => {
          this.itemList = list === null || list === void 0 ? void 0 : list.querySelectorAll('li');
        });
      }
    } else {
      close();
    }
  }
  onKeyDown(e) {
    var _this$container3;
    if ((_this$container3 = this.container) !== null && _this$container3 !== void 0 && _this$container3.classList.contains(listOpenClass)) {
      if (e.code === keyboardCodes.ENTER || e.code === keyboardCodes.ARROW_UP) {
        e.preventDefault();
      }
      if (e.code === keyboardCodes.TAB) {
        this.close();
      }
    }
  }
  onFocus() {
    if (this.showSuggestionsOnFocus) this.onChange();
  }
  onBlur(e) {
    if (this.container !== e.closest(".".concat(autocompleteClass))) {
      this.close();
    }
  }
  onKeyUp(e) {
    var _this$list2, _this$container4;
    switch (e.code) {
      case keyboardCodes.ARROW_DOWN:
        if ((_this$list2 = this.list) !== null && _this$list2 !== void 0 && _this$list2.children && this.itemSelected === this.list.children.length - 1) {
          var _this$list3;
          this.itemSelected = ((_this$list3 = this.list) === null || _this$list3 === void 0 ? void 0 : _this$list3.children.length) - 1;
        }
        this.itemSelected += 1;
        this.hoverElement();
        break;
      case keyboardCodes.ARROW_UP:
        if (this.itemSelected === 0) {
          return;
        }
        this.itemSelected -= 1;
        this.hoverElement();
        break;
      case keyboardCodes.ENTER:
        if (this.itemList.length && this.currentSuggestions[this.itemSelected] && (_this$container4 = this.container) !== null && _this$container4 !== void 0 && _this$container4.classList.contains(listOpenClass)) {
          this.onSelectHandler(e, this.currentSuggestions[this.itemSelected], this.currentSuggestions[this.itemSelected].name);
        }
        break;
      case keyboardCodes.ESCAPE:
        this.resetItemSelected();
        this.close();
        break;
      default:
        this.resetItemSelected();
        this.onChange();
        break;
    }
  }
  resetItemSelected() {
    this.itemSelected = this.showCurrentOption ? 0 : -1;
  }
  updateSuggestions(options) {
    this.suggestions = typeof options.suggestions === 'function' ? options.suggestions(options) : getSuggestions(options);
    this.onChange();
  }
}
var AutocompleteHandler$1 = AutocompleteHandler;
class Autocomplete extends React__default["default"].Component {
  constructor(props) {
    super(props);
    this.onKeyDownHandler = this.onKeyDownHandler.bind(this);
    this.onKeyUpHandler = this.onKeyUpHandler.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onClickOutsideHandler = this.onClickOutsideHandler.bind(this);
    this.handler = null;
    this.list = /*#__PURE__*/React.createRef();
    this.inputRef = /*#__PURE__*/React.createRef();
    this.container = /*#__PURE__*/React.createRef();
  }
  componentDidMount() {
    const inputRef = this.inputRef.current.querySelector('input');
    this.handler = new AutocompleteHandler$1(_objectSpread__default["default"]({
      field: inputRef,
      container: this.container.current,
      list: this.list.current
    }, this.props));
    document.addEventListener('click', this.onClickOutsideHandler);
  }
  componentWillUnmount() {
    document.removeEventListener('click', this.onClickOutsideHandler);
  }
  componentDidUpdate(prevProps) {
    const {
      suggestions
    } = this.props;
    if (prevProps.suggestions !== suggestions) {
      var _this$handler;
      const inputRef = this.inputRef.current.querySelector('input');
      (_this$handler = this.handler) === null || _this$handler === void 0 || _this$handler.updateSuggestions(_objectSpread__default["default"]({
        field: inputRef,
        container: this.container.current,
        list: this.list.current
      }, this.props));
    }
  }
  onKeyUpHandler(e) {
    var _this$handler2;
    (_this$handler2 = this.handler) === null || _this$handler2 === void 0 || _this$handler2.onKeyUp(e);
    const {
      onKeyUp
    } = this.props;
    if (typeof onKeyUp === 'function') {
      onKeyUp(e);
    }
  }
  onKeyDownHandler(e) {
    var _this$handler3;
    (_this$handler3 = this.handler) === null || _this$handler3 === void 0 || _this$handler3.onKeyDown(e);
    const {
      onKeyDown
    } = this.props;
    if (typeof onKeyDown === 'function') {
      onKeyDown(e);
    }
  }
  onClickOutsideHandler(e) {
    var _this$handler4;
    (_this$handler4 = this.handler) === null || _this$handler4 === void 0 || _this$handler4.onBlur(e.target);
  }
  onFocus(e) {
    var _this$handler5;
    (_this$handler5 = this.handler) === null || _this$handler5 === void 0 || _this$handler5.onFocus();
    const {
      onFocus
    } = this.props;
    if (typeof onFocus === 'function') {
      onFocus(e);
    }
  }
  render() {
    var _Children$only, _children$props, _children$props2;
    const {
      className,
      children,
      srLabel
    } = this.props;
    const inputId = (_Children$only = React.Children.only(children)) === null || _Children$only === void 0 || (_Children$only = _Children$only.props) === null || _Children$only === void 0 ? void 0 : _Children$only.id;
    const classes = classNames__default["default"]('andes-autocomplete', className);
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: classes,
      ref: this.container
    }, /*#__PURE__*/React.cloneElement(children, {
      ref: this.inputRef,
      onKeyUp: this.onKeyUpHandler,
      onKeyDown: this.onKeyDownHandler,
      onFocus: this.onFocus,
      srLabel,
      'aria-autocomplete': 'list',
      'aria-controls': inputId ? "".concat(inputId, "-listbox") : undefined,
      role: 'combobox'
    }), /*#__PURE__*/_jsx__default["default"]("div", {
      className: "andes-dropdown andes-dropdown--form"
    }, void 0, /*#__PURE__*/_jsx__default["default"]("div", {
      className: "andes-dropdown__popover"
    }, void 0, /*#__PURE__*/React__default["default"].createElement(list.List, {
      type: "dropdown",
      srLabel: srLabel || (children === null || children === void 0 || (_children$props = children.props) === null || _children$props === void 0 ? void 0 : _children$props.label) || (children === null || children === void 0 || (_children$props2 = children.props) === null || _children$props2 === void 0 ? void 0 : _children$props2.srLabel),
      ref: this.list,
      role: "listbox",
      id: inputId ? "".concat(inputId, "-listbox") : undefined
    }))));
  }
}
var Autocomplete$1 = Autocomplete;
exports.Autocomplete = Autocomplete$1;
exports["default"] = Autocomplete$1;
